import classes from "../../styles/DashboardView.module.css";

interface YoYLegendProps {
    currentColor: string;
    currentYearLabel: string;
    prevYearLabel: string;
    prevColor?: string;
    prevStyle?: "solid" | "dashed";
}

export function YoYLegend({ currentColor, currentYearLabel, prevYearLabel, prevColor, prevStyle = "solid" }: YoYLegendProps) {
    const swatchClass = prevStyle === "dashed"
        ? `${classes.yoySwatch} ${classes.yoySwatchDashed}`
        : `${classes.yoySwatch} ${classes.yoySwatchPrev}`;
    return (
        <div className={classes.yoyLegend}>
            <span className={classes.yoyLegendItem}>
                <span className={classes.yoySwatch} style={{ background: currentColor }} />
                {currentYearLabel}
            </span>
            <span className={classes.yoyLegendItem}>
                <span className={swatchClass} style={prevColor ? { background: prevColor } : undefined} />
                {prevYearLabel}
            </span>
        </div>
    );
}

export const PREV_COLOR = "#7d848e";

export function lightenMetricColor(color: string): string {
    if (color === "#2e7d32") return "#a5d6a7";
    if (color === "#1976d2") return "#90caf9";
    return PREV_COLOR;
}
